import dayjs from "dayjs";

export const getNextRepeatDate = (type, fromDate = dayjs()) => {
  const base = dayjs.isDayjs(fromDate) ? fromDate : dayjs();

  switch (type) {
    case 'Daily':
      return base.add(1, 'day');
    case 'Weekly':
      return base.add(1, 'week');
    case 'Monthly':
      return base.add(1, 'month');
    case 'Every 4 month':
      return base.add(3, 'month');
    case 'Every 6 month':
      return base.add(6, 'month');
    case 'Yearly':
      return base.add(1, 'year');
    case 'Never':
      return null;
    default:
      return null;
  }
};



